export const createRangeArray = (end: number, start = 1): number[] => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};
